import { addModal } from "../../../../../app.logic";
import lodash from "lodash";
import { modalStyleIFrame } from "../../../../../utils/constant";

import {
    createManageActive,
    createManageArchive,
    createManageDelete, createManageExportCsv, createManageExtraCreate,
    createManageSelect,
    createPage, createRowActionView
} from "../../../../../utils/page";
import { has } from "../../../../../utils/menu-context";
import { reactive, defineAsyncComponent } from "vue";

import {
    onClickActiveAll,
    onClickArchiveAll,
    onClickCreate,
    onClickDeleteAll,
    onClickView
} from "../../../../../utils/form";

import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createLoading } from "../../../../../utils/loading";
import { callSpeciesByGroup } from "../../../master-mgt/haz-object/haz-object.section";
import { useRoute } from "vue-router";

export const { isLoading, setIsLoading } = createLoading();
const CIFrame = defineAsyncComponent(() => import("../../../../../components/iframe/CIFrame"));

export const actionPrefix = "resource/v1/transaction/haz";
export const routerPrefix = 'haz-license-details'

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const onSearch = ({ page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.haz.approveCode"), dataIndex: "approveCode",  align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazObject.refSpecies"),
            dataIndex: "refHazObject.refSpecies.id",
            customRender: ({ record }) => <div>{record.refHazObject?.refSpecies?.value}</div>,
            inputProp: () => ({ list: callSpeciesByGroup, optLabel: "value" }),
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameTh"), dataIndex: "refHazObject.nameTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameEn"), dataIndex: "refHazObject.nameEn",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameTh"), dataIndex: "tradeNameTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameEn"), dataIndex: "tradeNameEn",  align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazInfo.nature"),
            dataIndexValue: ({ record }) =>
                record.isSolid === true
                    ? record.solid
                    : record.liquid,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("model.haz.manufacturer"), dataIndex: "manufacturer",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.refManufactureCountry"), dataIndex: "refManufactureCountry.nameTh",  align: "center" }),
    ]
    return columns
}

export const initState = ({ props }) => {
    const route = useRoute();
    const { menuContext } = props;
    state.manages = [
        createManageSelect({
            menuContext,
            type: !("5" === route.query?.key) ? "radio" : "checkbox",
        }),
        createManageActive({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }),
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [
        createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }),
            visible: () => !has({ menuContext, key: "canSelect", value: "true" }) })
    ];
    if(!has({ menuContext, key: "canSelect", value: "true" }) ) {
        state.rowActions = [
            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        ];
    }
};

export const createFormTitle = () => {
    return i18n.global.t("model.haz.desc")
};

export const openModalList = ({ bind, onIframeMounted, keyRequest }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/haz-license-details?isLayout=false&canSelect=true&cacheQuery=true&key=${keyRequest}`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        )
    });
    return options;
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ["**","refHazObject.refSpecies.*","refLastRequestHazLicense.refStatus.*"],
            children: [
                {
                    name: "hazLicenseDetails",
                    select: ["**","refHazLicense.refOperation.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
});
